module.exports = __webpack_public_path__ + "img/img_be_member_form2.d27fca0c.png";